/* eslint-disable react/jsx-props-no-spreading */
import { withRouter } from 'react-router-dom';

import React from 'react';

import { func, shape, string } from 'prop-types';
import {
  Container,
  Items,
} from './styles';

import SidebarItem from './sidebar-item';

const DashboardSidebar = (props) => {
  const { active, history } = props;

  const onSidebarItemClicked = (path) => () => {
    history.push(path);
  };

  const buildSidebarItemProps = (item) => {
    const path = `/${item}`;

    return {
      active: (active === item),
      onSidebarItemClicked: onSidebarItemClicked(path),
    };
  };

  return (
    <Container visible>
      <Items>
        <SidebarItem
          {...buildSidebarItemProps('approvals')}
          label="Approvals"
          icon="check circle outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('companies')}
          label="Companies"
          icon="building outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('manage-testers')}
          label="Manage Testers"
          icon="group"
        />
        <SidebarItem
          {...buildSidebarItemProps('projects')}
          label="Projects"
          icon="clipboard outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('testers')}
          label="Testers"
          icon="group"
        />
        {/* <SidebarItem
            {...buildSidebarItemProps('nlp-training')}
            label="NLP Training"
            icon="chart bar"
          /> */}
        <SidebarItem
          {...buildSidebarItemProps('controls')}
          label="Controls"
          icon="check circle outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('payments')}
          label="Payments"
          icon="check circle outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('audit')}
          label="Audit"
          icon="check circle outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('practice-tests')}
          label="Practice Tests"
          icon="archive"
        />
        <SidebarItem
          {...buildSidebarItemProps('moderated-recordings')}
          label="Moderated Recordings"
          icon="archive"
        />
        <SidebarItem
          {...buildSidebarItemProps('pricing')}
          label="Pricing"
          icon="archive"
        />
        <SidebarItem
          {...buildSidebarItemProps('clips')}
          label="Clips"
          icon="film"
        />
        <SidebarItem
          {...buildSidebarItemProps('sessions')}
          label="Sessions"
          icon="list alternate outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('uploads')}
          label="Uploads"
          icon="list alternate outline"
        />
        <SidebarItem
          {...buildSidebarItemProps('manage-audience')}
          label="Manage Audience"
          icon="list alternate outline"
        />
      </Items>
    </Container>
  );
};

DashboardSidebar.propTypes = {
  active: string.isRequired,
  history: shape({
    push: func,
  }).isRequired,
};

export default withRouter(DashboardSidebar);
